<template>
    <div class="bottom">
        <div class="left">
            <!-- <img src="../assets/iconFolder/common/common_icp_icon.png" alt=""> -->
            <span></span>
        </div>
        <div class="right">
            <div style="margin-right: 16px;">版权所有:中国地震局地球物理研究所</div>
            <div>技术支持:第四纪数字地球（北京）科技有限公司</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
}
</script>
<style scoped>
    .bottom {
        width: calc(100% - 32px);
        height: 52px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #777777;
        line-height: 20px;
    }
    .bottom .left {
        display: flex;
        align-items: center;
    }
    .bottom .left img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }
    .bottom .right {
        display: flex;
        align-items: center;
    }
</style>